import React from "react";
import {useSelector} from "react-redux";
import {Col, Row} from "reactstrap";
import SectionRow from "./sectionRow";
import {MIT_GBIZ} from "../core/const";
import Resource from "../core/serverResource";

const CompanyDetail = ({className, companyData}) => {

    const cluid = useSelector(state => state?.messenger?.cluid);
    const {legalCluid, companyName, registrationNumber, advisorName, user} = companyData;

    const format = (value, pattern) => {
        if (!value){
            return "";
        }
        var i = 0,
            phone = value.toString();
        return pattern.replace(/#/g, _ => phone[i++]);
    };

    return (
        <>
            <Row className={className}>
                <Col md={12}>
                    <SectionRow text={cluid} icon={Resource.getMitModule() === MIT_GBIZ ? "addressbook" : "s-id-app"} copy={true}/>
                    {companyData &&
                        <>
                            <hr className="mt-2 mb-3"/>
                            <SectionRow text={companyName} icon={"factory"}/>
                            <SectionRow text={legalCluid} icon={"factory"} copy={true}/>
                            <SectionRow text={registrationNumber} icon={"s-id-app"}/>
                            {advisorName && <SectionRow text={advisorName} icon={"bank"}/>}
                            {user &&
                                <>
                                    {user.workPhoneNumber && <SectionRow text={user.workPhoneNumber.length > 9 ? format(user.workPhoneNumber, '#### ### ### ###') : user.workPhoneNumber} icon={"phone-hotline"}/>}
                                    {user.workEmail && <SectionRow text={user.workEmail} icon={"mail"}/>}
                                    <SectionRow text={user.isLicenceAdmin ? "Je administrátorem pracovního prostoru" : "Není administrátorem pracovního prostoru"} icon={"security-user"}/>
                                </>
                            }
                        </>
                    }
                </Col>
            </Row>
        </>
    )
};

export default CompanyDetail;